import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2026 Sean FH</p>
        
        <a href="/privacy" className="footer-link">Privacy</a>
      </div>

      <img src="/assets/logo512 (1).png" alt="Sean FH Logo" className="footer-logo" />
    </footer>
  );
}